<template>
  <video 
    class="box"
    :src="detail.content"
    controls="controls" 
    x5-video-player-type="h5-page" 
    x5-video-player-fullscreen="true" 
    x5-playsinline="" 
    playsinline=""
    webkit-playsinline="true"
    x5-video-orientation="landscape"
  ></video>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vmax;
  height:100vmin;
  transform-origin: top left;
  transform: rotate(90deg) translateY(-100vmin);
  z-index: 100000;
}
</style>